export const tr = {
    'create-on-preset': 'Şablona göre oluştur',
    creatives: 'Kreatiflerim',
    ideas: 'Kreatifler için fikirler',
    presets: 'Standart şablonlar',
    title: 'Kreatif Sihirbazı'
};
